// $('ul.tabs li').click(function () {
//             var tab_id = $(this).attr('data-tab');
//             $(this).closest('.best-tabs').find('.tab-link').removeClass('active');
//             $(this).addClass('active');
//             $(this).closest('.best-tabs').find('.tab-content').removeClass('active');
//             $(this).closest('.best-tabs').find('.tab-content#' + tab_id).addClass('active');
//         });


$('ul.tabs li').click(function () {
    var tab_id = $(this).attr('data-tab');
    
    $(this).closest('.best-tabs').find('.tab-link').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.best-tabs').find('.tab-content').removeClass('active');
    var $tabContent = $(this).closest('.best-tabs').find('.tab-content#' + tab_id);
    $tabContent.addClass('active');
    
    $('html, body').animate({
        scrollTop: $tabContent.offset().top - 100
    }, 500);
});




// document.addEventListener('DOMContentLoaded', (event) => {
//   // Function to add 'active' class to the next set of products
//   function showMoreProducts(tabContent, clickCount, isInitialLoad = false) {
//     console.log('showMoreProducts called. Click Count:', clickCount, 'isInitialLoad:', isInitialLoad);
//     const products = tabContent.querySelectorAll('.show-more-product:not(.active)');
//     let count = 0;

//     // Determine how many products to activate
//     let productsToActivate = 3;
//     if (isMobileScreen()) {
//       if (isInitialLoad) {
//         productsToActivate = 4;
//       } else if (clickCount * 4) {
//         productsToActivate = 4;
//       } else {
//         productsToActivate = 3;
//       }
//     }

//     products.forEach(product => {
//       if (count < productsToActivate) {
//         product.classList.add('active');
//         count++;
//       }
//     });

//     const remainingProducts = tabContent.querySelectorAll('.show-more-product:not(.active)');
//     if (remainingProducts.length === 0) {
//       const showMoreButton = tabContent.querySelector('.showmore_products');
//       if (showMoreButton) {
//         showMoreButton.classList.add('hidden');
//       }
//     }
//   }

//   // Function to check if the screen width is considered mobile
//   function isMobileScreen() {
//     return window.innerWidth <= 1022;
//   }

//   // Activate default products in each tab-content
//   const allTabContents = document.querySelectorAll('.tab-content');
//   allTabContents.forEach(tabContent => {
//     showMoreProducts(tabContent, 0, true);
//   });

//   // Event listener for each Show More button within its corresponding tab-content
//   const showMoreButtons = document.querySelectorAll('.tab-content .showmore_products');
//   showMoreButtons.forEach(button => {
//     let clickCount = 0;
//     button.addEventListener('click', () => {
//       clickCount++;
//       console.log('Button clicked. Click Count:', clickCount);
//       const tabContent = button.closest('.tab-content');
//       showMoreProducts(tabContent, clickCount);
//     });
//   });
// });


  function initializeSwiper() {
            var swiper = new Swiper('.cat-tab', {
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                // centeredSlides: true,
                // Autoplay
                // autoplay: {
                //     delay: 2500,
                //     disableOnInteraction: false,
                // },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.4,
                        spaceBetween: 10
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2.4,
                        spaceBetween: 20
                    }
                }
            });
        }

        // Check screen width and initialize swiper if on mobile
        if (window.innerWidth < 768) {
            initializeSwiper();
        }

        // Re-check on window resize
        window.addEventListener('resize', function() {
            if (window.innerWidth < 768) {
                if (!document.querySelector('.swiper-container-initialized')) {
                    initializeSwiper();
                }
            }
        });


// document.addEventListener('DOMContentLoaded', function() {
//   // Function to check if the screen is in mobile view
//   function isMobileView() {
//     return window.innerWidth <= 768; // Adjust the width as per your definition of mobile view
//   }

//   // Function to update active classes based on screen size
//   function updateActiveClasses() {
//     var tabContents = document.querySelectorAll('.tab-content');
//     tabContents.forEach(function(tabContent) {
//       var showMoreProducts = tabContent.querySelectorAll('.show-more-product');
//       var defaultCount = isMobileView() ? 4 : 3; // Determine the default count based on screen width
//       var showMoreButton = tabContent.querySelector('.showmore_products');
      
//       // Check the state of the tab content
//       var isExpanded = tabContent.getAttribute('data-expanded') === 'true';

//       if (showMoreProducts.length > 0) {
//         // Hide the "Tap For More" button if there are less than or equal to defaultCount products
//         if (showMoreProducts.length <= defaultCount) {
//           showMoreButton.style.display = 'none';
//         } else {
//           showMoreButton.style.display = 'inline-flex'; // or 'block' based on your layout needs
//         }

//         // Update the active state based on whether the tab is expanded or not
//         for (var i = 0; i < showMoreProducts.length; i++) {
//           if (isExpanded || i < defaultCount) {
//             showMoreProducts[i].classList.add('active');
//           } else {
//             showMoreProducts[i].classList.remove('active');
//           }
//         }
//       } else {
//         console.error("No '.show-more-product' found in tab content:", tabContent);
//       }
//     });
//   }

//   // Call the function initially and on window resize
//   updateActiveClasses();
//   window.addEventListener('resize', updateActiveClasses);

//   // Event listener for the Show More Products button
//   var showMoreButtons = document.querySelectorAll('.showmore_products');
//   showMoreButtons.forEach(function(button) {
//     button.addEventListener('click', function() {
//       var tabContent = button.closest('.tab-content');
//       var showMoreProducts = tabContent.querySelectorAll('.show-more-product');
//       if (showMoreProducts.length > 0) {
//         if (button.textContent === 'Tap For Less') {
//           var defaultCount = isMobileView() ? 4 : 3; // Determine the default count based on screen width
//           for (var i = defaultCount; i < showMoreProducts.length; i++) {
//             showMoreProducts[i].classList.remove('active');
//           }
//           button.textContent = 'Tap For More';
//           button.classList.remove('show-less');
//           tabContent.setAttribute('data-expanded', 'false');

//           // Scroll to the tab content with a top offset of 70px
//           $('html, body').animate({
//             scrollTop: $(tabContent).offset().top - 70
//           }, 500); // 500 milliseconds for the scroll animation
//         } else {
//           showMoreProducts.forEach(function(product) {
//             product.classList.add('active');
//           });
//           button.textContent = 'Tap For Less';
//           button.classList.add('show-less');
//           tabContent.setAttribute('data-expanded', 'true');
//         }
//       } else {
//         console.error("No '.show-more-product' found in tab content:", tabContent);
//       }
//     });
//   });
// });




// document.addEventListener('DOMContentLoaded', function() {
//   // Function to check if the screen is in mobile view
//   function isMobileView() {
//     return window.innerWidth <= 768; // Adjust the width as per your definition of mobile view
//   }

//   // Function to update active classes based on screen size
//   function updateActiveClasses() {
//     var tabContents = document.querySelectorAll('.tab-content');
//     tabContents.forEach(function(tabContent) {
//       var showMoreProducts = tabContent.querySelectorAll('.show-more-product');
//       var defaultCount = isMobileView() ? 4 : 3; // Determine the default count based on screen width
//       var showMoreButton = tabContent.querySelector('.showmore_products');

//       if (showMoreProducts.length > 0) {
//         // Hide the "Tap For More" button if there are less than 4 products
//         if (showMoreProducts.length <= defaultCount) {
//           showMoreButton.style.display = 'none';
//         } else {
//           showMoreButton.style.display = 'inline-flex'; // or 'block' based on your layout needs
//         }

//         for (var i = 0; i < showMoreProducts.length; i++) {
//           if (i < defaultCount) {
//             showMoreProducts[i].classList.add('active');
//           } else {
//             showMoreProducts[i].classList.remove('active');
//           }
//         }
//       } else {
//         console.error("No '.show-more-product' found in tab content:", tabContent);
//       }
//     });
//   }

//   // Call the function initially and on window resize
//   updateActiveClasses();
//   window.addEventListener('resize', updateActiveClasses);

//   // Event listener for the Show More Products button
//   var showMoreButtons = document.querySelectorAll('.showmore_products');
//   showMoreButtons.forEach(function(button) {
//     button.addEventListener('click', function() {
//       var tabContent = button.closest('.tab-content');
//       var showMoreProducts = tabContent.querySelectorAll('.show-more-product');
//       if (showMoreProducts.length > 0) {
//         if (button.textContent === 'Tap For Less') {
//           var defaultCount = isMobileView() ? 4 : 3; // Determine the default count based on screen width
//           for (var i = defaultCount; i < showMoreProducts.length; i++) {
//             showMoreProducts[i].classList.remove('active');
//           }
//           button.textContent = 'Tap For More';
//           button.classList.remove('show-less');

//           // Scroll to the tab content with a top offset of 100px
//           $('html, body').animate({
//             scrollTop: $(tabContent).offset().top - 100
//           }, 500); // 500 milliseconds for the scroll animation
//         } else {
//           showMoreProducts.forEach(function(product) {
//             product.classList.add('active');
//           });
//           button.textContent = 'Tap For Less';
//           button.classList.add('show-less');
//         }
//       } else {
//         console.error("No '.show-more-product' found in tab content:", tabContent);
//       }
//     });
//   });
// });


